// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Video from '../_raw/ui/icon_video.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Video);
